
import { defineComponent, ref } from 'vue';
import { useList } from '@/hooks/use-list';
import { getV1AccountInfoApi } from '@/api/manage-app/account-info';
import { GetV1AccountInfoApiResItem } from '@/api/manage-app/account-info/index.d';
import CreatedDevAccount from './components/created-dev-account.vue';
import DisabledDevAccount from './components/disabled-dev-account.vue';
import DevAccountLogs from './components/dev-account-logs.vue';
import CreatedDevApp from './components/created-dev-app.vue';

import { useCreatedDevAccount, useCreatedDevAPP } from './composables/index';
import { APP_IS_ENABLED_LIST, APP_LIST_ENUM } from '@/constant';
import usePermissionConfig from './use-permission-config';

export default defineComponent({
  name: 'DevAccountManage',
  components: {
    CreatedDevAccount,
    DisabledDevAccount,
    DevAccountLogs,
    CreatedDevApp,
  },
  setup() {
    const {
      params,
      tableData,
      tableLoading,
      handleSearch,
    } = useList<GetV1AccountInfoApiResItem>({
      request: {
        api: getV1AccountInfoApi,
        params: {},
      },
      response: {
        tableDataKey: 'data',
      },
    });
    handleSearch();
    const {
      createdDevVisible,
      handleCreated,
      handelEdit,
      handleDisabled,
      disabledVisible,
      handleRenew,
      handleShowLogs,
      logVisible,
      accountItem,
      gridData,
      handleEnable,
    } = useCreatedDevAccount();

    const {
      createdAPPVisible,
      handleAPPCreated,
      handleAPPEnable,
      handleAPPDel,
      accountAppItem,
      handelAppEdit,
      accountId,
      accountInfoId,
    } = useCreatedDevAPP();

    const permissionConfig = usePermissionConfig();

    const expands = ref([] as string[]);
    const expandChange = (row: GetV1AccountInfoApiResItem, expandedRows: GetV1AccountInfoApiResItem[]) => {
      expands.value = expandedRows.map((item: GetV1AccountInfoApiResItem) => item.id);
    };

    return {
      params,
      tableData,
      tableLoading,
      handleSearch,
      createdDevVisible,
      handleCreated,
      handelEdit,
      handleDisabled,
      handleEnable,
      disabledVisible,
      handleRenew,
      handleShowLogs,
      logVisible,
      gridData,
      createdAPPVisible,
      handleAPPCreated,
      handleAPPEnable,
      handleAPPDel,
      handelAppEdit,
      accountAppItem,
      accountId,
      accountInfoId,
      APP_IS_ENABLED_LIST,
      APP_LIST_ENUM,
      accountItem,
      permissionConfig,
      expands,
      expandChange,
    };
  },
});
